import React, { lazy, Suspense } from "react";

// 동적 import로 변경 - 코드 스플리팅
// 각 Menu 컴포넌트가 별도의 청크로 분리되어 필요할 때만 로드됨
// 자사용 메뉴 (jcrm001-007) - MenuJ1-7
const MenuJ1 = lazy(() => import("./menuJ1/MenuJ1"));
const MenuJ2 = lazy(() => import("./menuJ2/MenuJ2"));
const MenuJ3 = lazy(() => import("./menuJ3/MenuJ3"));
const MenuJ4 = lazy(() => import("./menuJ4/MenuJ4"));
const MenuJ5 = lazy(() => import("./menuJ5/MenuJ5"));
const MenuJ6 = lazy(() => import("./menuJ6/MenuJ6"));
const MenuJ7 = lazy(() => import("./menuJ7/MenuJ7"));

// 업체용 메뉴 (ocrm001-007) - MenuO1-7
const MenuO1 = lazy(() => import("./menuO1/MenuO1"));
const MenuO2 = lazy(() => import("./menuO2/MenuO2"));
const MenuO3 = lazy(() => import("./menuO3/MenuO3"));
const MenuO4 = lazy(() => import("./menuO4/MenuO4"));
const MenuO5 = lazy(() => import("./menuO5/MenuO5"));
const MenuO6 = lazy(() => import("./menuO6/MenuO6"));
const MenuO7 = lazy(() => import("./menuO7/MenuO7"));

// 로딩 컴포넌트
const MenuLoader = () => (
  <div style={{ 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center", 
    height: "100%",
    color: "#666",
    fontSize: "14px"
  }}>
    로딩 중...
  </div>
);

function Menu(props) {
  return <li>{props.name}</li>;
}

function MenuDiv(props) {
  // 모든 컴포넌트를 항상 렌더링하되, 코드만 동적으로 로드
  // Tabs 컴포넌트의 display: none/block이 상태를 유지시킴
  // 한 번 로드된 컴포넌트는 언마운트되지 않아 상태가 유지됨
  
  // 자사용 메뉴 (jcrm001-007)
  return (
    <>
      {props.id === "jcrm001" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuJ1 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
      {props.id === "jcrm002" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuJ2 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
      {props.id === "jcrm003" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuJ3 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
      {props.id === "jcrm004" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuJ4 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
      {props.id === "jcrm005" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuJ5 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
      {props.id === "jcrm006" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuJ6 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
      {props.id === "jcrm007" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuJ7 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
      {/* 업체용 메뉴 (ocrm001-007) */}
      {props.id === "ocrm001" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuO1 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
      {props.id === "ocrm002" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuO2 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
      {props.id === "ocrm003" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuO3 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
      {props.id === "ocrm004" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuO4 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
      {props.id === "ocrm005" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuO5 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
      {props.id === "ocrm006" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuO6 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
      {props.id === "ocrm007" && (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Suspense fallback={<MenuLoader />}>
            <MenuO7 name={props.name} selected={props.selected} />
          </Suspense>
        </div>
      )}
    </>
  );
}

export { Menu, MenuDiv };
